// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nWUH5u {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--color-background-primary, #ffffff);
}

.nWUH5u.O3_mt2 {
  height: auto;
  min-height: 100%;
}

.O3_mt2 .VnocDW {
  padding: 16px 24px 24px;
}

.O3_mt2 .NJ7V4Y {
  flex: none;
  overflow: visible;
  padding: 0 24px;
}

.VnocDW {
  padding: 20px;
}

.NJ7V4Y {
  flex: 1;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.ksUt1N {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  flex: 1;
}

.YPda4G {
  margin-top: 16px;
  color: var(--color-text-secondary, #6c757d);
  font-size: 14px;
  line-height: 1.5;
}

.um0Vim {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  flex: 1;
}

.L3ckAz {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #fee;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.urXtSa {
  font-size: 28px;
}

.Lu6lwF {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary, #212529);
  margin: 0 0 8px 0;
}

.UsoRFl {
  font-size: 14px;
  color: var(--color-text-secondary, #6c757d);
  margin: 0;
  line-height: 1.5;
  max-width: 400px;
}

.J8_W7J {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  flex: 1;
}

.fkIvK9 {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--color-background-secondary, #f8f9fa);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.ovXJry {
  font-size: 28px;
}

.U2eoLb {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary, #212529);
  margin: 0 0 8px 0;
}

._u207i {
  font-size: 14px;
  color: var(--color-text-secondary, #6c757d);
  margin: 0;
  line-height: 1.5;
  max-width: 400px;
}

@media (max-width: 768px) {
  .VnocDW {
    padding: 16px;
  }

  .NJ7V4Y {
    padding: 16px;
  }

  .ksUt1N,
  .um0Vim,
  .J8_W7J {
    padding: 32px 16px;
  }

  .L3ckAz,
  .fkIvK9 {
    width: 56px;
    height: 56px;
    margin-bottom: 20px;
  }

  .urXtSa,
  .ovXJry {
    font-size: 24px;
  }

  .Lu6lwF,
  .U2eoLb {
    font-size: 16px;
  }

  .UsoRFl,
  ._u207i {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .VnocDW {
    padding: 12px;
  }

  .NJ7V4Y {
    padding: 12px;
  }

  .ksUt1N,
  .um0Vim,
  .J8_W7J {
    padding: 24px 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}

@media (prefers-contrast: high) {
  .VnocDW {
    border-bottom-width: 2px;
  }

  .L3ckAz {
    background-color: #ff6b6b;
    color: white;
  }

  .fkIvK9 {
    background-color: #6c757d;
    color: white;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeHistoryContainer/RechargeHistoryContainer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background-color: var(--color-background-primary, #ffffff);\n}\n\n.container.migrationHistory {\n  height: auto;\n  min-height: 100%;\n}\n\n.migrationHistory .searchSection {\n  padding: 16px 24px 24px;\n}\n\n.migrationHistory .contentSection {\n  flex: none;\n  overflow: visible;\n  padding: 0 24px;\n}\n\n.searchSection {\n  padding: 20px;\n}\n\n.contentSection {\n  flex: 1;\n  padding: 20px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  flex: 1;\n}\n\n.loadingText {\n  margin-top: 16px;\n  color: var(--color-text-secondary, #6c757d);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.errorContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  flex: 1;\n}\n\n.errorIcon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: #fee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.errorIconText {\n  font-size: 28px;\n}\n\n.errorTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary, #212529);\n  margin: 0 0 8px 0;\n}\n\n.errorDescription {\n  font-size: 14px;\n  color: var(--color-text-secondary, #6c757d);\n  margin: 0;\n  line-height: 1.5;\n  max-width: 400px;\n}\n\n.emptyContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  flex: 1;\n}\n\n.emptyIcon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: var(--color-background-secondary, #f8f9fa);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.emptyIconText {\n  font-size: 28px;\n}\n\n.emptyTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary, #212529);\n  margin: 0 0 8px 0;\n}\n\n.emptyDescription {\n  font-size: 14px;\n  color: var(--color-text-secondary, #6c757d);\n  margin: 0;\n  line-height: 1.5;\n  max-width: 400px;\n}\n\n@media (max-width: 768px) {\n  .searchSection {\n    padding: 16px;\n  }\n\n  .contentSection {\n    padding: 16px;\n  }\n\n  .loadingContainer,\n  .errorContainer,\n  .emptyContainer {\n    padding: 32px 16px;\n  }\n\n  .errorIcon,\n  .emptyIcon {\n    width: 56px;\n    height: 56px;\n    margin-bottom: 20px;\n  }\n\n  .errorIconText,\n  .emptyIconText {\n    font-size: 24px;\n  }\n\n  .errorTitle,\n  .emptyTitle {\n    font-size: 16px;\n  }\n\n  .errorDescription,\n  .emptyDescription {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .searchSection {\n    padding: 12px;\n  }\n\n  .contentSection {\n    padding: 12px;\n  }\n\n  .loadingContainer,\n  .errorContainer,\n  .emptyContainer {\n    padding: 24px 12px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition: none !important;\n    animation: none !important;\n  }\n}\n\n@media (prefers-contrast: high) {\n  .searchSection {\n    border-bottom-width: 2px;\n  }\n\n  .errorIcon {\n    background-color: #ff6b6b;\n    color: white;\n  }\n\n  .emptyIcon {\n    background-color: #6c757d;\n    color: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `nWUH5u`,
	"migrationHistory": `O3_mt2`,
	"searchSection": `VnocDW`,
	"contentSection": `NJ7V4Y`,
	"loadingContainer": `ksUt1N`,
	"loadingText": `YPda4G`,
	"errorContainer": `um0Vim`,
	"errorIcon": `L3ckAz`,
	"errorIconText": `urXtSa`,
	"errorTitle": `Lu6lwF`,
	"errorDescription": `UsoRFl`,
	"emptyContainer": `J8_W7J`,
	"emptyIcon": `fkIvK9`,
	"emptyIconText": `ovXJry`,
	"emptyTitle": `U2eoLb`,
	"emptyDescription": `_u207i`
};
module.exports = ___CSS_LOADER_EXPORT___;
